import React from 'react';
import styled from 'styled-components';

// Components
import { Spacing } from '@doordash/design-language';
import { Button, Input } from 'top-component-library';

// Types
import { ButtonProps } from 'antd';
import { button } from 'constants/style';

// Constants
import breakpoints from 'constants/breakpoints';

export const SaveButton: React.FunctionComponent<ButtonProps> = styled(Button)`
  width: 100%;
  height: ${button.regular}px;
`;

export const CancelButton: React.FunctionComponent<ButtonProps> = styled(Button)`
  width: 100%;
  height: ${button.regular}px;
  margin-right: 1rem; // Used to space out buttons on desktop mode

  color: var(--color-button-primary__regular);
  &:focus,
  &:hover {
    border-color: var(--color-button-primary__regular);
    color: var(--color-button-primary__regular);
  }
`;

export const PaymentError = styled.div`
  .ant-alert {
    margin-bottom: 0;
    margin-top: 1rem;
  }
`;

export const PaymentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 0;

  // Desktop styling
  @media (min-width: ${breakpoints.md}px) {
    gap: 1rem;
  }
`;

export const PaymentMethodFormContainer = styled.div`
  height: 100%;

  .StripeElement {
    padding: 0;
    box-shadow: none;
    width: 100%;
    max-width: none;
    margin: 0;
  }
`;

export const ButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Buttons = styled.div`
  width: 100%;
  display: flex;
  padding: 16px ${Spacing.None};
`;

export const NormalFontWeight = styled.span`
  font-weight: normal;
  color: var(--color-neutral__label);
`;

// CustomStripePaymentFormContainer Styles

export const CustomStripePaymentFormContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  justify-content: start;
  flex-wrap: wrap;

  .StripeElement {
    padding: 0;
    box-shadow: none;
    width: 100%;
    max-width: none;
    margin: 0;
  }
`;

// Format the stripe input field as much as we can
export const StripeInput = styled.div``;
export const StripeInputWrapper = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;

  box-sizing: border-box;

  height: 40px;
  border-radius: 8px;
  border: 1px solid #d9d9d9;
  padding-left: 12px;
  padding-right: 12px;

  &:hover {
    border: 1px solid #191919;
    transition: all 0.3s;
  }

  &:has(> .StripeElement--focus) {
    border: 1px solid #191919;
    transition: all 0.3s;
    box-shadow: #191919 0px 0px 0px 1px inset;
  }

  &:has(> .StripeElement--invalid) {
    border: 1px solid var(--color-error__regular);
    transition: all 0s;
    box-shadow: var(--color-error__regular) 0px 0px 0px 1px inset;
  }
`;

export const StripeCell = styled.div`
  display: flex;
  width: 100%;
`;

// Prevenet flex from affecting stripe input
export const StripeCellProtector = styled.div`
  display: block;
  width: 100%;
`;

export const ExpCvcRow = styled.div`
  display: flex;
  flex-direction: row;
  wrap: none;
  gap: 1rem;
`;

export const ZipInput = styled(Input)`
  margin: 0;

  font-family: sans-serif;
  color: var(--color-neutral__title-active);
  font-size: 16px;
  font-weight: normal;

  ::placeholder {
    font-family: sans-serif;
    color: var(--color-neutral__placeholder);
    font-size: 16px;
    font-weight: normal;
  }

  &.invalid {
    border: 1px solid var(--color-error__regular);
    transition: all 0s;
    box-shadow: var(--color-error__regular) 0px 0px 0px 1px inset;
    color: var(--color-error__regular);
  }
`;
